import { Pipe, PipeTransform } from '@angular/core';
import { FileRecordDto } from '@careapp-group/ng-sdk';

/**
 * From an array, returns a media item matching the purpose desired.
 *
 * Example usage for retreiving a small logo from branding:
 * > (branding$ | async)?.media | mediaPurpose: 'smallLogo' as media;
 */
@Pipe({
    name: 'mediaPurpose',
    pure: true,
    standalone: false
})
export class MediaPurposePipe implements PipeTransform {
  transform(value: Array<FileRecordDto>, purpose: string) {
    if (!Array.isArray(value) || !purpose) {
      return;
    }
    return value.find((item) => item.purpose === purpose);
  }
}
